var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-card-cover",class:_vm.image ? 'blog-card-cover--photo' : 'blog-card-cover--' + _vm.theme},[(_vm.image)?_c('img',{staticClass:"blog-card-cover__photo",attrs:{"src":_vm.image,"alt":_vm.alt,"width":"280","height":"158","loading":"lazy"}}):[_c('span',{staticClass:"blog-card-cover__label"},[_vm._v(_vm._s(_vm.label))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }